import { selectSubsidiariesState } from '../index';
import { createSelector } from '@ngrx/store';
import { SubsidiariesState } from '../reducers/subsidiaries.reducer';

export const selectSubsidiaries = createSelector(
  selectSubsidiariesState,
  (state: SubsidiariesState) => state && state.subsidiaries
);
export const selectAllSubsidiariesSorted = createSelector(selectSubsidiaries, (subsidiaries) => {
  if (subsidiaries) {
    return [...subsidiaries].sort((a, b) => a.name.localeCompare(b.name));
  } else {
    return [];
  }
});
export const selectSubsidiariesLoading = createSelector(
  selectSubsidiariesState,
  (state: SubsidiariesState) => state && state.loading
);
export const selectSubsidiariesError = createSelector(
  selectSubsidiariesState,
  (state: SubsidiariesState) => state && state.error
);

export const selectSubsidiaryNameById = (id: string) =>
  createSelector(selectAllSubsidiariesSorted, (subsidiaries) => {
    const subsidiary = subsidiaries?.find((sub) => sub.objectId === id);
    return subsidiary ? subsidiary.name : null;
  });

export const selectSubsidiariesSorted = createSelector(selectSubsidiaries, (subsidiaries) => {
  if (subsidiaries) {
    return [...subsidiaries].sort((a, b) => a.name.localeCompare(b.name));
  }
  return [];
});

export const selectSubsidiaryById = (id: string | undefined) =>
  createSelector(selectSubsidiaries, (subsidiaries) => {
    if (subsidiaries && id) {
      return subsidiaries.find((s) => s.objectId === id) || null;
    }
    return null;
  });
